import IRestServiceFilters, {isFilterNested} from "../../interface/api/IRestServiceFilters";
import IRestResource from "../../interface/api/IRestResource";
import {API_FILTER_TYPE, API_TOKEN} from "../../constants/ApiConstant";
import IRestServiceFilter from "../../interface/api/IRestServiceFilter";
import Utils from "../../../utils";
import FormFieldType from "../../../components/app/configuration/form/FormElement/formField/FormFieldType";
import IContentType from "../../interface/dataStorage/IContentType";
import FieldEditor from "../../../components/app/configuration/form/FormElement/optionEditor/FieldEditor";
import IUser from "../../interface/security/IUser";
import moment from "moment";
import store from "../../../redux/store";
import selectors from "../../../redux/selectors/Services";
import IRepositoryService from "../../interface/IRepositoryService";
import {RELATION_FIELD_TYPE} from "../../interface/dataStorage/IField";
import IRestServiceFilterNested from "../../interface/api/IRestServiceFilterNested";


const FilterEvaluationService = {
    evaluateByType: function (filter: IRestServiceFilter, resource: IRestResource, service: IRepositoryService, user: IUser): boolean {
        const chain = filter.field.split('.')
        let currentService: IRepositoryService|null = service
        if (chain.length > 1){
            let nestedResult: boolean | null = null
            chain.forEach((item, index) => {
                const field = service?.getFields().find(f => f.name === item)!
                if (field?.targetEntity && index + 1 < chain.length){
                    currentService = selectors.findOneOrNullByFullClassName(store.getState(), field.targetEntity)
                    if (currentService && [RELATION_FIELD_TYPE.ONE_TO_MANY,RELATION_FIELD_TYPE.MANY_TO_MANY].includes(field.type) && Array.isArray(resource[item])){
                       nestedResult = resource[item].some((item: IRestResource) => {
                            return !!currentService && this.evaluateByType({...filter, field: chain.slice(index + 1).join('.')}, item, currentService, user);
                        })
                    }
                    resource = !nestedResult ? resource?.[item] : resource
                }

            })
            if (nestedResult !== null){
                return nestedResult
            }
        }

        if (!service){
            return false;

        }

        const field = currentService.getFields().find(f => f.name === chain[chain.length - 1]);
        if (!field){
            return false;

        }
        let value = FormFieldType.formatToForm(FieldEditor.detectType(field), resource[field.name])
        let filterValue = FormFieldType.formatToForm(FieldEditor.detectType(field), filter.value)
        const identifier = Utils.isUuid(Array.isArray(filterValue) ? filterValue[0] : filterValue) ? 'uuid' : 'id'
        value = Utils.parseObjectToIdentifier(value, identifier)
        filterValue = this.parseToken(filterValue, user)

        switch (filter.type) {
            case API_FILTER_TYPE.EQUAL:
                return filterValue === value
            case API_FILTER_TYPE.NOT_EQUAL:
                return filterValue !== value
            case API_FILTER_TYPE.LESSER:
                return !!filterValue && filterValue > value
            case API_FILTER_TYPE.LESSER_OR_EQUAL:
                return !!filterValue && filterValue >= value
            case API_FILTER_TYPE.GREATER:
                return !!filterValue && filterValue < value
            case API_FILTER_TYPE.GREATER_OR_EQUAL:
                return !!filterValue && filterValue <= value
            case API_FILTER_TYPE.CONTAINS:
                return Array.isArray(value) && Array.isArray(filterValue) &&
                    filterValue.every(item => value.includes(item))
            case API_FILTER_TYPE.CONTAINS_NOT:
                return Array.isArray(value) && Array.isArray(filterValue) &&
                    !filterValue.every(item => value.includes(item))
            case API_FILTER_TYPE.IN:
                return Array.isArray(filterValue) && filterValue.includes(value as never)
            case API_FILTER_TYPE.NOT_IN:
                return Array.isArray(filterValue) && !filterValue.includes(value as never)
            case API_FILTER_TYPE.LIKE:
                return Utils.stringContains(value, filterValue)
            case API_FILTER_TYPE.LIKE_BEGINNING:
                return Utils.stringStartsWith(value, filterValue) && resource.value
            case API_FILTER_TYPE.IS_NOT_NULL:
                return Array.isArray(value) ? value.length > 0 : !!value
            case API_FILTER_TYPE.IS_NULL:
                return !value || (Array.isArray(value) && value.length === 0)
            default:
                return false

        }
    }, evaluate: function (filters: IRestServiceFilters, resource: IRestResource, contentType: IContentType, user: IUser, or: boolean = false) {
        const filterValues = Object.values(filters);

        const checkFilter = (filter: IRestServiceFilter | IRestServiceFilterNested): boolean => {
            if (isFilterNested(filter)) {
                return this.evaluate(filter.children, resource, contentType, user, filter.type === API_FILTER_TYPE.OR);
            } else {
                const service: IRepositoryService | null = selectors.findOneOrNullByFullClassName(store.getState(), contentType.fullClassName);
                return !!service && this.evaluateByType(filter, resource, service, user);
            }
        };

        if (or) {
            return filterValues.some(checkFilter);
        }
        return !!filterValues.length && filterValues.every(checkFilter);
    },
    parseToken: function (value: any, user: IUser) {
        switch (value){
            case API_TOKEN.NOW:
                return moment()
            case API_TOKEN.EMPLOYEE:
                return user.currentEmployee
            case API_TOKEN.USER:
                return user.uuid
            case API_TOKEN.VIRTUAL_EMPLOYEE:
                return user.currentEmployee ? user.employees.find(e => e.uuid === user.currentEmployee)?.virtualEntityIdUuid : undefined
            default:
                return value
        }
    },
    parseTokenID: function (value: any, user: IUser) {
        switch (value){
            case API_TOKEN.NOW:
                return moment()
            case API_TOKEN.EMPLOYEE:
                return user.currentEmployee ? user.employees.find(e => e.uuid === user.currentEmployee)?.id : undefined
            case API_TOKEN.VIRTUAL_EMPLOYEE:
                return user.currentEmployee ? user.employees.find(e => e.uuid === user.currentEmployee)?.virtualEntityId : undefined
            case API_TOKEN.USER:
                return user.id
            case API_TOKEN.JOB:
                return user.currentEmployee ? user.employees.find(e => e.uuid === user.currentEmployee)?.job?.id : undefined
            case API_TOKEN.UNIT:
                return user.currentEmployee ? user.employees.find(e => e.uuid === user.currentEmployee)?.unit?.id : undefined
            case API_TOKEN.COMPANY:
                return user.currentEmployee ? user.employees.find(e => e.uuid === user.currentEmployee)?.company?.id : undefined
            default:
                return value
        }
    }
}

export default FilterEvaluationService